import { USER_STATUS } from 'constants/status';

const notEditableFields: string[] = [
  USER_STATUS.active,
  USER_STATUS.accountProcessing,
  USER_STATUS.accountCreationFailed,
];

const nameEditable: string[] = [
  USER_STATUS.draft,
  USER_STATUS.invited,
  USER_STATUS.accepted,
  USER_STATUS.kycNotStarted,
];

export const disabledField = (profileStatus: string): boolean =>
  notEditableFields.includes(profileStatus);

export const disabledEmail = (profileStatus: string): boolean =>
  profileStatus !== USER_STATUS.draft;

export const enabledName = (profileStatus: string): boolean =>
  nameEditable.includes(profileStatus);

export const disabledNextBillingDate = (profileStatus: string): boolean =>
  profileStatus !== USER_STATUS.active;

export const disabledCustodian = (profileStatus: string): boolean =>
  [...notEditableFields, USER_STATUS.accepted].includes(profileStatus);
